// extracted by mini-css-extract-plugin
module.exports = {"containerBoundary":"containerBoundary_containerBoundary__x5eUB","legacy":"containerBoundary_legacy__lkiJg"};